<template>
  <CRow>
    <CCol lg="12">
      <CCard>
        <CCardHeader>
          <h3 style="font-weight: bold;">Công cụ quản lý</h3>
        </CCardHeader>
        <CCardBody>
          <CListGroup>
            <CListGroupItem v-for="(item, index) in contents" :key="index">
              <!-- Header -->
              <h6 style="font-weight: bold;"><CIcon name="cil-hand-point-right" size="lg" class="me-2 mr-1"/>{{ item.header }}</h6>
              <!-- Nested List -->
              <CCollapse show>
                <ul>
                  <li v-for="(subItem, subIndex) in item.content" :key="subIndex">
                    <!-- <CIcon name="cil-chevron-right"/> -->
                    <span v-html="subItem"></span>
                  </li>
                </ul>
              </CCollapse>
            </CListGroupItem>
          </CListGroup>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

export default {
  data() {
    return {
      contents: [
        {
          header: "Quản lý linh kiện",
          content: [
            `Biên tập template linh kiện:</br>
              - Bước 1: Tạo mô tả linh kiện trong tệp .xlsx trên máy tính</br>
              - Bước 2: Vào: Kho -> Nhập/Xuất -> Tạo linh kiện từ tệp -> Chọn tệp -> Tải lên</br>
              - Bước 3: Kiểm tra linh kiện đã được tạo: Kho -> Tìm kiếm -> Lựa chọn (kiểm tra tên linh kiện đã xuất hiện?) </br>
              - Bước 4: Tạo linh kiện: Kho -> Tìm kiếm -> Lựa chọn -> Tạo mới (nhập thông tin cần thiết và ấn lưu)`,
            `Kiểm soát số lượng linh kiện và nhập-xuất:</br>
              - Vào: Kho -> Tìm kiếm -> Lựa chọn -> Tìm kiếm để tìm một loại linh kiện bất kỳ</br>
              - Thông tin linh kiện được thể hiện trong bảng nếu tìm thấy</br>
              - Ấn nút 'Thao tác' sau đó ấn vào nút tương ứng để kiểm tra số lượng đặt trước, thông tin nhập-xuất và chỉnh sửa của linh kiện</br>`,
            `Tạo danh mục mua, xuất-nhập kho thủ công:</br>
              - Vào: Kho -> Nhập/Xuất ->  Tạo danh mục -> Màn hình chuyển sang trang tìm kiếm linh kiện với hai phần trên (danh mục) và dưới (tìm kiếm)</br>
              - Tại mục Tìm kiếm ấn nút Lựa chọn (nếu cần chọn loại linh kiện nhất định, để nguyên nếu tìm tất cả) sau đó ấn Tìm kiếm </br>
              - Kết quả Tìm kiếm hiển thị, sau đó nhập số lượng cần vào ô nhập</br>
              - Ấn nút Thêm/cập nhật mục đã chọn để đưa những linh kiện đã chọn vào danh mục</br>
              - Để thay đổi số lượng trong danh mục, nhập số lượng cần thiết vào ô nhập sau đó ấn nút Thêm/cập nhật mục đã chọn</br>
              - Ấn nút Chọn tất cả/Bỏ chọn tất cả để chọn/bỏ chọn nhanh</br>
              - Tại phần Danh mục, tích chọn những mục không cần và ấn: 'Bỏ mục đã chọn' để loại bỏ khỏi danh mục</br>
              - Sau khi chọn đủ-đúng số lượng linh kiện ấn vào xuất danh mục linh kiện, màn hình tải tệp xuất hiện để lưu tệp danh mục</br>
              - Tùy vào yêu cầu tệp đó có thể dùng làm danh mục mua hàng, nhập kho hoặc xuất kho`,
          ],
        },
        {
          header: "Quản lý Dự án và BOM",
          content: [
            `Tạo dự án mới:</br>
              - Vào: Dự án -> Thêm mới -> Nhập thông tin dự án (quy tắc đặt tên: < Tên sản phẩm>-< Tên khách hàng>-< Thời gian bắt đầu dự án></br>
              - Ấn lưu sau khi đã nhập đủ thông tin (tối thiểu các trường có dấu *)`,
            `Chỉnh sửa/ cập nhật trạng thái dự án:</br>
              - Vào: Dự án -> Bấm vào dự án muốn chỉnh sửa -> cập nhật nội dung dự án -> Lưu</br>`,
            `Xem thông tin sản xuất, giao hàng, bảo hành của dự án:</br>
              - Vào: Dự án -> Bấm vào dự án muốn xem, nội dung sản xuất, giao hàng, bảo hành được hiển thị bằng thanh tiến trình, ấn vào thanh tiến trình để xem chi tiết</br>`,
            `Tạo - Biên tập BOM:</br>
              - Tại màn hình thông tin dự án, chọn Tạo mới (để tạo mới) hoặc Biên tập (để chỉnh sửa) BOM</br>
              - Nếu chọn Tạo mới, điền tên BOM và số lượng sản phẩm khi cửa sổ nhập xuất hiện, sau đó ấn Lưu </br>
              - Tại màn hình Biên tập BOM, mục Thông tin thiết kế, ấn chọn tệp BOM schematic để nhập thông tin thiết kế (tệp .xlsx)</br>
              - Tại mục Thông tin tổng hợp sau xử lý, kết quả xử lý BOM được thể hiện, mục còn thiếu được bôi đỏ</br>
              - Tại mục Rà soát kho, nhập thông tin rà soát theo yêu cầu để ra số lượng thiếu và số lượng cần mua (nếu có)</br>
              - Tại mục Danh mục mua, nhập số lượng mua ở mỗi loại còn thiếu (bôi đỏ), ấn vào nút xuất danh mục mua để tạo tệp danh mục</br>
              - Sau khi nhập kho linh kiện thiếu, ấn nút Đồng bộ để cập nhật lại tình trạng, nếu toàn bộ thỏa mãn sẽ xuất BOM và xuất kho</br>
              - Tùy chọn gửi email những danh mục cần mua</br>`,
          ],
        },
        {
          header: "Nhắc nhở",
          content: [`Nhắc nhở người dùng về tình trạng linh kiện thiếu`],
        },
        {
          header: "Quản lý sản phẩm",
          content: [
            `Xem thiết bị kết nối online: vào: Quản lý -> Kết nối`,
            `Xem thiết bị thiết bị đã sản xuất theo số seri, unique id, mac, lô sản xuất, số lượng, thời gian`,
            `Quản lý giấy phép tính năng thiết bị:</br>
              - Quản lý -> Giấy phép xem những giấy phép đã tạo</br>
              - Tạo mới giấy phép</br>`,
            `Quản lý giao hàng:</br>
              - Mô tả sản phẩm</br>
              - Thời gian, địa điểm, tên người (giao/nhận)</br> `,
            `Quản lý bảo hành:</br>
              - Hàng nhận bảo hành (tên hàng, thời gian, số lượng)</br>
              - Người sửa chữa</br>
              - Vật tư sửa chữa</br>
              - Thời gian trả bảo hành`,
          ],
        },
      ],
    };
  },
  created() {

  },
  mounted() {
  },
  methods: {

  }
};
</script>

<style scoped>
/* Optional: Add spacing or styles for better appearance */
ul {
  padding-left: 1rem;
}

</style>
